import type { ITrialEndedSuggestPlanFeature } from '../types';

import { MultiPageIcon, PagePackageIcon, PathAnalysisIcon } from '~/presentation/icons';
import { ChartLineIcon, ChatIcon } from '@shopify/polaris-icons';
import { Icon } from '@shopify/polaris';
import { IPlanKey } from '../types';

export const TRIAL_ENDED_SUGGEST_PLAN_FEATURES: Partial<
  Record<IPlanKey, ITrialEndedSuggestPlanFeature[]>
> = {
  [IPlanKey.FUNNEL_OPT]: [
    {
      title: 'Unlimited experiments',
      icon: <Icon source={MultiPageIcon} tone="subdued" />,
    },
    {
      title: 'Unlimited page analytics',
      icon: <Icon source={ChartLineIcon} tone="subdued" />,
    },
    {
      title: 'Multiple page testing',
      icon: <Icon source={PagePackageIcon} tone="subdued" />,
    },
    {
      title: 'Live chat support',
      icon: <Icon source={ChatIcon} tone="subdued" />,
    },
    {
      title: 'Journey analysis',
      icon: <Icon source={PathAnalysisIcon} tone="subdued" />,
    },
  ],
};
